import React, { useCallback, useContext, useEffect, useMemo, useRef, useState } from "react";
import { Box, Button, Checkbox, Grid, IconButton, Modal, TextField, ThemeProvider, Tooltip, Typography } from "@mui/material";
import { Controller, useForm } from "react-hook-form";
import { ContextNotification, severitys } from "../../../App";
import { yupResolver } from '@hookform/resolvers/yup';
import * as yup from 'yup';
import customtheme from '../../../themes';
import { useSelector } from 'react-redux';
import RtlProvider from "../../../Components/RtlProvider"
import { ContextUserInfo } from "../../../Layout/MainLayout";
import '../../../Styles/react-tagsinput.css'
import brokerGroupApi from "../../../api/brokerGroupApi";
import BeatLoading from "../../../Components/Loader/BeatLoader";
import FlightCompensationApi from "../../../api/FlightCompensationApi";
import helper from "../../../helper";
import { RHFAutocomplete } from "../../../Components/RHFAutocomplete";
import staticVariablesApi from "../../../api/staticVariablesApi";
import EditAirLineSlA from "./EditAirLineSLA";
import EnumMapper from "../../../EnumMapper";
import { MaterialReactTable, useMaterialReactTable } from "material-react-table";
import AccessControl from "../../../Components/AccessControl";
import ConfirmationDialog from "../../../Components/ConfirmationDialog";
import { MdAirlines, MdDelete, MdEditSquare } from "react-icons/md";
import CustomTitle from "../../../Components/CustomTitle";
import { MdOutlineAirplaneTicket } from "react-icons/md";
import { MdTimelapse } from "react-icons/md";
import EditAirLineAgeGroupRate from "./EditAirLineAgeGroupRate";
import EditAirLinePenaltyRate from "./EditAirLinePenaltyRate";
import CloseIcon from '@mui/icons-material/Close';



const AirLineSLAList = () => {


    const { userInfo, userPermissions, userRoles } = useContext(ContextUserInfo);
    const [data, setData] = useState([]);
    const { open, setOpen } = React.useContext(ContextNotification);
    const [isError, setIsError] = useState(false);
    const [isLoading, setIsLoading] = useState(false);
    const [isRefetching, setIsRefetching] = useState(false);
    const [rowCount, setRowCount] = useState(0);
    const [operations, setOperations] = useState([]);
    const [airLines, setAirLines] = useState([]);
    //table state
    const [columnFilters, setColumnFilters] = useState([]);
    const [globalFilter, setGlobalFilter] = useState('');
    const [sorting, setSorting] = useState([]);
    const [pagination, setPagination] = useState({
        pageIndex: 0,
        pageSize: 10,
    });

    const customization = useSelector((state) => state.customization);
    const schema = yup.object().shape({

    });
    const { register, setValue, handleSubmit, formState: { errors }, control, resetField, reset, getValues, watch } = useForm({
        resolver: yupResolver(schema),
    });
    const GetOperationDropDown = () => {
        brokerGroupApi.GetOprationDropDown().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setOperations(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        }
        )
            .catch((error) => {
                console.log(error);
            })
    }
    const GetAirLineDropDown = () => {
        staticVariablesApi.GetAirLineType().then((res) => {
            const arr = helper.DictionayToList(res.data.data);
            setAirLines(arr.map((o) => {
                return {
                    id: o.key,
                    label: o.value
                };
            }));
        }
        )
            .catch((error) => {
                console.log(error);
            })
    }

    const columns = useMemo(
        () => [

            {
                accessorKey: 'operationTitle',
                id: 'operationTitle',
                header: 'عملیات عمره',
                size: 50,
            },
            {
                accessorKey: 'airLineTitle',
                id: 'airLineTitle',
                header: 'شرکت هواپیمایی',
                size: 150,
            },
            {
                accessorKey: 'dutiesAndTaxes',
                id: 'dutiesAndTaxes',
                header: 'مالیات و عوارض',
                size: 50,
            },
            {
                accessorKey: 'departureCurrencyTitle',
                id: 'departureCurrencyTitle',
                header: 'ارز خروجی',
                size: 50,
            },
            {
                accessorKey: 'returnCurrencyTitle',
                id: 'returnCurrencyTitle',
                header: 'ارز بازگشتی',
                size: 50,
            }
        ],
        [],)
    const table = useMaterialReactTable({
        columns,
        data,
        enableRowSelection: true,
        // getRowId: (row) => row.phoneNumber,

        manualFiltering: true,
        manualPagination: true,
        manualSorting: true,
        muiToolbarAlertBannerProps: isError
            ? {
                color: 'error',
                children: 'Error loading data',
            }
            : undefined,
        onColumnFiltersChange: setColumnFilters,
        onGlobalFilterChange: setGlobalFilter,
        onPaginationChange: setPagination,
        onSortingChange: setSorting,
        rowCount,
        state: {
            columnFilters,
            globalFilter,
            isLoading,
            pagination,
            showAlertBanner: isError,
            showProgressBars: isRefetching,
            sorting,
        }
        , localization: {

            sortByColumnAsc: '',
            sortByColumnDesc: '',
            sortedByColumnAsc: '',
            sortedByColumnDesc: '',

            // ... and many more - see link below for full list of translation keys
        },

        enableFilters: false,
        enableRowSelection: false,
        muiTableHeadCellProps: {
            //simple styling with the `sx` prop, works just like a style prop in this example
            sx: {
                backgroundColor: 'rgb(113, 185, 172)',
                textAlign: 'right'
            },
        },
        muiTableBodyCellProps: ({ column }) => ({
            //conditionally style pinned columns
            sx: {
                textAlign: 'right',
            },
        }),
        muiTableBodyProps: {
            sx: {
                //stripe the rows, make odd rows a darker color
                '& tr:nth-of-type(odd) > td': {
                    backgroundColor: '#f5f5f5',
                },
            },
        },
        renderRowActions: ({ row }) => (

            <Box sx={{ display: 'flex', flexWrap: 'nowrap', gap: '8px' }}>
                {
                    // AccessControl.checkPermissions(userPermissions, ["AirLineSLA:Delete"])
                    // &&
                    <Tooltip title="حذف توافقنامه">
                        <IconButton
                            color="error"
                            onClick={() => handleOpenConfirmDeleteModal(row.original)}
                        >
                            <MdDelete />
                        </IconButton>
                    </Tooltip>
                }
                {
                    //   AccessControl.checkPermissions(userPermissions, ["AirLineSLA:Edit"])
                    // &&
                    <Tooltip title="ویرایش توافقنامه">
                        <IconButton
                            color="primary"
                            onClick={() => handleEditSLA(row.original)}
                        >
                            <MdEditSquare />
                        </IconButton>
                    </Tooltip>
                }
                {
                    <Tooltip title="ثبت هزینه بلیط برای هر گروه سنی">
                        <IconButton
                            color="primary"
                            onClick={() => handleOpenAgrGrpRateModal(row.original)}
                        >
                            <MdOutlineAirplaneTicket />
                        </IconButton>
                    </Tooltip>
                }
                {
                    <Tooltip title="ثبت درصد خسارت براساس ساعت تاخیر">
                        <IconButton
                            color="primary"
                            onClick={() => handleOpenPenaltyRateModal(row.original)}
                        >
                            <MdTimelapse />
                        </IconButton>
                    </Tooltip>
                }

            </Box>
        ),
        enableRowActions: true,
        positionActionsColumn: 'last',
        displayColumnDefOptions: {
            'mrt-row-actions': {
                header: '', //change header text
                size: 300, //make actions column wider

            },
            'mrt-row-expand': {
                header: '', //change header text
                muiTableHeadCellProps: {
                    align: 'right',
                },
                muiTableBodyCellProps: {
                    align: 'right',
                },
            },
        },
    });


    useEffect(() => {
        GetOperationDropDown();
        GetAirLineDropDown();
        ResetForm();
    }, [])

    const ResetForm = () => {
        setOpenSLADelete(false);
        setSelectedSLA(null);
        setOpenAgeGrpRateModal(false);
        setOpenPenaltyRateModal(false);
        setOpenSLAEdit(false);
        GetAirLineSLA();
    }

    const onSubmit = () => {
        GetAirLineSLA();
    }
    const GetAirLineSLA = () => {

        var operationId = null;
        if (watch("operationId"))
            operationId = parseInt(watch("operationId"));
        var airline = null;
        if (watch("airLineId"))
            airline = parseInt(watch("airLineId"));
        const filterData = {
            "airLineType": airline,
            "operation": operationId,
            "orderDescending": sorting.length > 0 ? sorting[0].desc : true,
            "pageNumber": pagination.pageIndex + 1,
            "pageSize": pagination.pageSize,
        }
        setIsLoading(true);
        FlightCompensationApi.FilterAirLineSLA(filterData).then((res) => {
            const values = (res.data.data ? res.data.data.items.map((itm) => { return itm.data }) : []);
            setData(values);
            const rowcnt = res.data.data ? res.data.data.totalCount : 0;
            setRowCount(rowcnt);
            const selectedslaid = selectedSLA?.id;
            
            if (selectedslaid) {
                setSelectedSLA(values?.find((itm) => itm.id === selectedslaid));
            }

        }
        ).catch((err) => {
            if (err.response?.data) {
                setOpen({ IsEnable: true, Message: err.response.data.title, severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
        })
            .finally(() => setIsLoading(false));
    }


    ///////edit//////////////////////////////////////////////////////////
    const [selectedSLA, setSelectedSLA] = useState(null);
    const [openSLAEdit, setOpenSLAEdit] = useState(false);
    const handleEditSLA = (row) => {
        if (selectedSLA?.id !== row.id) {

            setSelectedSLA(row);
            setOpenSLAEdit(true);
        }

        else {
            setSelectedSLA(null);
            setOpenSLAEdit(false);

        }

    }


    ////////delete///////////////////////////////////////////////////////

    const [openSLADelete, setOpenSLADelete] = useState(false);
    const handleOpenConfirmDeleteModal = (row) => {
        setSelectedSLA(row);
        setOpenSLADelete(true);
    }
    const handleDeleteSLA = () => {
        FlightCompensationApi.deleteAirLineSLA(selectedSLA.id).then((res) => {
            if (res.data.success) {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.success });
                ResetForm();
            }
            else {
                setOpen({ IsEnable: true, Message: res.data.message, severity: severitys.error });
            }
        }).catch(err => {
            if (err.response && err.response.data && err.response.data.errors) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data.errors), severity: severitys.error });
            }
            else if (err.response && err.response.data) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.response.data), severity: severitys.error });
            }
            else if (err.message) {
                setOpen({ IsEnable: true, Message: JSON.stringify(err.message), severity: severitys.error });
            }
            else {
                setOpen({ IsEnable: true, Message: JSON.stringify(err), severity: severitys.error });
            }
        }
        ).finally(() => { ResetForm() });
    }
    ////////AgeGeoupRate////////////////////////////////////////////////
    const [openAgeGrpRateModal, setOpenAgeGrpRateModal] = useState(false);
    const handleOpenAgrGrpRateModal = (row) => {
        setSelectedSLA(row);
        setOpenAgeGrpRateModal(true);
    }
    const handleCloseAgrGrpRateModal = () => {
        setSelectedSLA(null);
        setOpenAgeGrpRateModal(false);
    }
    ////////PenaltiRate////////////////////////////////////////////////
    const [openPenaltyRateModal, setOpenPenaltyRateModal] = useState(false);
    const handleOpenPenaltyRateModal = (row) => {
        setSelectedSLA(row);
        setOpenPenaltyRateModal(true);
    }
    const handleClosePenaltyRateModal = () => {
        setSelectedSLA(null);
        setOpenPenaltyRateModal(false);
    }

    const modalStyle1 = {
        position: 'absolute',
        display: 'flex',
        overflowX: 'auto',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '35%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        pt: 2,
        px: 2,
        pb: 2,
        overflow: 'scroll',

    };

    const modalStyle2 = {
        position: 'absolute',
        display: 'flex',
        overflowX: 'auto',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: '45%',
        bgcolor: 'background.paper',
        border: '2px solid #000',
        boxShadow: 24,
        p: 4,
        pt: 2,
        px: 2,
        pb: 2,
        overflow: 'scroll',

    };

    return (
        <ThemeProvider theme={customtheme(customization)}>
            <RtlProvider>
                <CustomTitle title={'لیست توافقنامه هواپیمایی '} icon={<MdAirlines size={20} />} />
                {(openSLAEdit) && <Box sx={{ background: '#f1f8f3ff', border: 'solid 2px #8aad9aff', borderRadius: 3, mt: 2, mb: 2 }}>
                    <EditAirLineSlA row={selectedSLA} Refresh={() => { ResetForm(); }} /></Box>}
                <form onSubmit={handleSubmit(onSubmit)}>

                    <Grid container spacing={1}>
                        <Grid item md={2} xs={3.5}>
                            <RHFAutocomplete
                                control={control}
                                options={operations}
                                name="operationId"
                                placeholder="عملیات عمره"
                                style={{
                                    border: "none",
                                    padding: 0
                                }}
                            />
                            <p className="error">{errors.operationId?.message}</p>
                        </Grid>
                        <Grid item md={2} xs={3.5}>
                            <RHFAutocomplete
                                control={control}
                                options={airLines}
                                name="airLineId"
                                placeholder="شرکت هواپیمایی"
                                style={{
                                    border: "none",
                                    padding: 0
                                }}
                            />
                            <p className="error">{errors.airLineId?.message}</p>
                        </Grid>
                        <Grid item size={4} spacing={1} md={2} xs={3.5} sx={{ mt: 1 }} >
                            <Button type="submit" variant="contained" color="primary"  >
                                جستجو
                            </Button>
                        </Grid>
                    </Grid>
                </form>
            </RtlProvider>


            {isLoading && <BeatLoading />}
            <div dir="rtl">
                <Box sx={{ display: "flex", flexDirection: 'column' }}>
                     <Typography ><Box sx={{ textAlign: 'left', dir: 'rtl',m:1 }}>{'تعداد نتایج'+':'+rowCount} </Box></Typography>
                </Box>

                <MaterialReactTable table={table} />
            </div>

            <ConfirmationDialog
                open={openSLADelete}
                handleClose={() => setOpenSLADelete(false)}
                deleteFunction={() => handleDeleteSLA()}
            />
            <Modal

                open={openAgeGrpRateModal}
                onClose={handleCloseAgrGrpRateModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >

                <Box sx={modalStyle1}>
 <IconButton
          aria-label="بستن"
          onClick={handleCloseAgrGrpRateModal}
          sx={{
            position: 'absolute',
           left: 8,
            top: 8,
          color:'#04636E'
          }}
        >
          <CloseIcon color='#04636E' />
        </IconButton>
                    <EditAirLineAgeGroupRate row={selectedSLA} Refresh={() => { GetAirLineSLA() }} />

                </Box>
            </Modal>
            <Modal

                open={openPenaltyRateModal}
                onClose={handleClosePenaltyRateModal}
                aria-labelledby="modal-modal-title"
                aria-describedby="modal-modal-description"
            >
                <Box sx={modalStyle2}>
 <IconButton
          aria-label="بستن"
          onClick={handleClosePenaltyRateModal}
          sx={{
            position: 'absolute',
           left: 8,
            top: 8,
          color:'#04636E'
          }}
        >
          <CloseIcon color='#04636E' />
        </IconButton>
                    <EditAirLinePenaltyRate row={selectedSLA} Refresh={() => { GetAirLineSLA() }} />

                </Box>
            </Modal>

        </ThemeProvider>
    )
}
export default AirLineSLAList